import { ITaskData, navigation, task } from '@origin-digital/reporting-client';
import * as React from 'react';
import { USERNAME } from 'ts/constants/UrlParams';
import { ROUTES } from 'ts/Routes';
import { AccountFoundView } from './AccountFoundView';
import { getForgotPasswordUrl } from '../../../../login/services/urlService';
import { History } from 'history';
import { QuickLoginForm } from 'ts/login/components/QuickLogin/QuickLoginForm';
import { FeatureSwitch } from '@origin-digital/features';
import { navigateToErrorPage } from '../error/ErrorNavigation';
import { ErrorFlow } from '../error/ErrorFlow';

interface AccountFoundPageProps {
  history: History;
  location: Location;
}

class AccountFoundPage extends React.PureComponent<AccountFoundPageProps> {
  public componentDidMount() {
    navigation('screen', {
      currentUri: '',
      friendlyUri: 'originenergy:my-account:auth:forgot-email-success',
    });

    task.base(
      'forgot-email' as any,
      {
        action: 'complete',
      } as ITaskData,
    );
  }

  public render() {
    const forgotPasswordHref = `${getForgotPasswordUrl()}?${USERNAME}=${this.getEmail()}`;
    return (
      <AccountFoundView
        email={this.getEmail()}
        forgotPasswordHref={forgotPasswordHref}
        onLoginClick={this.onLoginClick}
      >
        <FeatureSwitch name="sales-r2d2-account-found-login">
          <QuickLoginForm
            history={this.props.history}
            location={this.props.location}
            username={this.getEmail()}
            // TODO might need annie for analytics in a later story placeholder for now
            errorPageFunction={(errorCode, history) =>
              navigateToErrorPage(errorCode, ErrorFlow.forgotEmail, '', history, true)
            }
          />
        </FeatureSwitch>
      </AccountFoundView>
    );
  }

  private getEmail = () => new URLSearchParams(this.props.location.search).get(USERNAME);

  private onLoginClick = () => {
    this.props.history.push({
      pathname: ROUTES.LOGIN,
      search: `?${USERNAME}=${this.getEmail()}`,
    });
  };
}

export { AccountFoundPage };
